<template>
  <q-table
    flat
    bordered
    :data="reports"
    row-key="transaction_id"
    :columns="conversionColumns"
    :pagination.sync="pagination"
    :visible-columns="visibleColumns"
  >
    <template v-slot:top-right>
      <q-btn
        outline
        color="grey-3"
        size="12px"
        text-color="grey-8"
        icon-right="archive"
        class="q-mr-sm q-py-xs"
        no-caps
        @click="exportCsvClickReport()"
        unelevated
        :disable="reqPagination.total == 0 || reqPagination.total > 100000"
      >
        <q-tooltip>
          {{ reqPagination.total > 100000 ? $t('limit_lines_exceeded') : $t('export_csv') }}
        </q-tooltip>
      </q-btn>
      <q-select
        v-model="visibleColumns"
        multiple
        outlined
        dense
        options-dense
        :display-value="$t('customize_columns')"
        emit-value
        map-options
        :options="conversionColumns"
        option-value="name"
        options-cover
        style="min-width: 150px"
      >
        <template v-slot:option="{ itemProps, itemEvents, opt, selected, toggleOption }">
          <q-item v-bind="itemProps" v-on="itemEvents" @click="saveLocalColumns(itemProps.active, opt.name)">
            <q-item-section>
              <q-item-label v-html="opt.label"></q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-toggle :value="selected" @input="toggleOption(opt)" />
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </template>

    <template v-slot:body-cell-cj_customer_status="props">
      <q-td :props="props">
        <div>
          {{
            props.row.cust_status ? $t(props.row.cust_status ? props.row.cust_status.toLowerCase() : 'not_mapped') : ''
          }}
        </div>
      </q-td>
    </template>

    <template v-slot:body-cell-comission_rule_name="props">
      <commission-rule-cell :props="props" />
    </template>

    <template v-slot:bottom>
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        <div class="row items-center">
          <span class="q-mr-md">{{ $t('rows_per_page') }}</span>
          <q-select
            v-model="pagination.rowsPerPage"
            :options="adjustedRowsPerPageOptions"
            map-options
            dense
            @input="onRowsPerPageChange"
            style="max-width: 60px; padding-left: 8px; padding-right: 8px"
          />
          <span>Total: {{ reqPagination.total }}</span>
        </div>
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
  </q-table>
</template>

<script>
import ReportMixin from '../../mixins/ReportMixin';
import CommissionRuleCell from './CommissionRuleCell.vue';

export default {
  name: 'ListConversionReports',
  components: { CommissionRuleCell },
  mixins: [ReportMixin],
  watch: {
    async currentPage() {
      if (this.reqPagination.from != null && this.reqPagination.from != this.reqPagination.current_page) {
        await this.getConversionReport(`page=${this.currentPage}`, `%26per_page=${this.pagination.rowsPerPage - 1}`);
        if (this.reports.length > 0) {
          this.updateReports();
        }
      }
    },
    visibleColumns() {
      if (this.reports && this.reports[10]) {
        if (this.visibleColumns.includes('campaign_id')) {
          this.reports[10].campaign_id = 'TOTAL:';
          this.reports[10].campaign_name = '';
        } else {
          this.reports[10].campaign_id = '';
          this.reports[10].campaign_name = 'TOTAL:';
        }
      }
    }
  },

  created() {
    const savedRowsPerPage = localStorage.getItem('rowsPerPage');
    this.pagination.rowsPerPage = savedRowsPerPage ? parseInt(savedRowsPerPage) : 11;

    this.ActionSetFilterReports(
      `test_campaigns=0` +
        '%26start_date=' +
        this.$moment().subtract(1, 'days').format('YYYY-MM-DD') +
        '%26end_date=' +
        this.$moment().format('YYYY-MM-DD')
    );
    this.ActionSetReports();
    this.getLocalStorage = Object.entries(localStorage);
    this.localColumns = Object.fromEntries(this.getLocalStorage);
    function getKey(columns) {
      const arr = [],
        obj = Object.keys(columns);
      for (var x in obj) {
        if (columns[obj[x]] == 'true') {
          arr.push(obj[x]);
        }
      }
      return arr;
    }

    if (getKey(this.localColumns) && getKey(this.localColumns).length != 0) {
      this.visibleColumns = getKey(this.localColumns);
    } else {
      this.visibleColumns = [
        'campaign_name',
        'site_name',
        'order_id',
        'transaction_id',
        'bonus_id',
        'creative_type',
        'coupon_code',
        'attribution_policy',
        'comission_rule_name',
        'transaction_amount',
        'full_commission_amount',
        'affiliate_commission_cost',
        'afilio_commition_margin',
        'xtrasParams1',
        'click_datetime',
        'transaction_datetime',
        'time_diff',
        'ip',
        'validation_status',
        'source_url',
        'first_url'
      ];
    }
    for (var x in this.visibleColumns) {
      localStorage.setItem(this.visibleColumns[x], true);
    }

    this.getConversionReport(null, '%26per_page=' + this.pagination.rowsPerPage - 1);
    if (this.reports) this.updateReports();
  },

  data() {
    return {
      visibleColumns: null,
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: 11
      }
    };
  },

  methods: {
    async exportCsvClickReport() {
      let columnsCsv = this.conversionColumns.filter((item) => this.visibleColumns.includes(item.name));

      this.onLoading(true);
      let filter = '';
      if (this.filterReports !== undefined) filter = this.filterReports.replace('id_affiliate', 'affiliate_id');
      try {
        const { data, status } = await this.$http.get('redirect?app=report&path=/api/get/report/export_csv?' + filter);
        if (status === 200 && !data.message) {
          this.exportTableCsv(data, columnsCsv, 'conversion_reports');
          this.successNotify('Exportado com sucesso!');
        } else this.successNotify(data.message);
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },
    labelStatus(status) {
      switch (status) {
        case 0:
          return this.$t('refused');
        case 1:
          return this.$t('pending');
        case 2:
          return this.$t('approved');
        case 3:
          return this.$t('billed');
        case 4:
          return this.$t('paid');
        default:
          return '';
      }
    },
    saveLocalColumns(itemPropsActive, optName) {
      localStorage.setItem(optName, !itemPropsActive);
    },
    updateReports() {
      const totalIndex = this.pagination.rowsPerPage - 1;
      this.reports.splice(totalIndex, 0, {
        campaign_name: 'TOTAL:',
        transaction_amount: this.parseMoney(this.reportsTotal[0].transaction_amount),
        full_commission_amount: this.parseMoney(this.reportsTotal[0].full_commission_amount),
        affiliate_commission_cost: this.parseMoney(this.reportsTotal[0].affiliate_commission_cost),
        afilio_commition_margin: this.parseMoney(this.reportsTotal[0].afilio_commition_margin),
        created_at: this.$moment().format('YYYY-MM-DD')
      });

      this.$nextTick(() => {
        const rows = document.querySelectorAll('.q-table tbody tr');
        rows.forEach((row) => {
          const columns = row.querySelectorAll('td');
          columns.forEach((column) => {
            if (column.innerText.trim() === 'TOTAL:') {
              row.classList.add('total-row');
            }
          });
        });
      });
    },
    async onRowsPerPageChange(option) {
      const rowsPerPage = option.value;
      this.pagination.rowsPerPage = rowsPerPage;
      localStorage.setItem('rowsPerPage', rowsPerPage);

      await this.getConversionReport(null, `%26per_page=${rowsPerPage - 1}`);
      if (this.reports.length > 0) {
        this.updateReports();
      }
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    },

    adjustedRowsPerPageOptions() {
      return [11, 21, 51, 101].map((option) => ({
        label: (option - 1).toString(),
        value: option
      }));
    }
  }
  //   mounted() {
  //     this.getConversionReport().then(() => {
  //       this.updateReports();
  //     });
  //   }
};
</script>
<style>
.total-row td {
  font-weight: bold;
}
</style>
